<template>
  <div class="ttshop_user">
    <Header></Header>
    <Userheader></Userheader>
    <div class="ttshop_user">
      <div class="ttshop_usercon w clearfloat">
        <!-- 个人中心导航 -->
        <Usernavleft></Usernavleft>
        <div class="ttshop_useright">
          <!-- 发票信息 -->
          <div class="ttshop_coupon min_h">
            <div class="flexsb">
              <div class="fap_title">新增发票抬头</div>
            </div>
            <!-- form表单-->
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
              label-position="top"
              size="small"
            >
              <el-form-item label="发票类型:" prop="resource">
                <el-radio-group
                  v-model="ruleForm.resource"
                  @change="individual"
                >
                  <el-radio :label="1">个人</el-radio>
                  <el-radio :label="2">企业</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="发票类型:" label-width="280px" prop="region">
                <el-select
                  v-model="ruleForm.region"
                  placeholder="请选择发票类型"
                  @change="regionchange"
                >
                  <el-option
                    label="增值税普通发票"
                    v-if="ruleForm.resource == 1"
                    value="0"
                  ></el-option>
                  <el-option
                    label="增值税普通发票"
                    v-if="ruleForm.resource == 2"
                    value="1"
                  ></el-option>
                  <el-option
                    label="增值税专用发票"
                    v-if="ruleForm.resource == 2"
                    value="2"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="发票抬头:"
                label-width="280px"
                prop="invoicetitle"
              >
                <el-input v-model="ruleForm.invoicetitle"></el-input>
              </el-form-item>
              <el-form-item
                v-if="ruleForm.resource != 1"
                label="纳税人识别码:"
                label-width="280px"
                prop="taxpayer"
              >
                <el-input v-model="ruleForm.taxpayer"></el-input>
              </el-form-item>
              <el-form-item
                label="开户行:"
                label-width="280px"
                prop="openingbank"
                v-if="
                  ruleForm.resource != 1 &&
                  (ruleForm.region == 2 || invoice_type == 2)
                "
              >
                <el-input v-model="ruleForm.openingbank"></el-input>
              </el-form-item>
              <el-form-item
                v-if="
                  ruleForm.resource != 1 &&
                  (ruleForm.region == 2 || invoice_type == 2)
                "
                label="银行账户:"
                label-width="280px"
                prop="bankaccount"
              >
                <el-input v-model="ruleForm.bankaccount"></el-input>
              </el-form-item>
              <el-form-item
                v-if="
                  ruleForm.resource != 1 &&
                  (ruleForm.region == 2 || invoice_type == 2)
                "
                label="注册地址:"
                label-width="280px"
                prop="address"
              >
                <el-input v-model="ruleForm.address"></el-input>
              </el-form-item>
              <el-form-item
                label="注册电话:"
                label-width="280px"
                prop="phone"
                v-if="
                  ruleForm.resource != 1 &&
                  (ruleForm.region == 2 || invoice_type == 2)
                "
              >
                <el-input v-model="ruleForm.phone"></el-input>
              </el-form-item>
              <el-form-item label-width="280px" prop="checked">
                <el-checkbox v-model="ruleForm.checked">
                  我已阅读并同意
                </el-checkbox>
                <span class="red" @click.stop="increased"
                  >《增票资质确认书》</span
                >
              </el-form-item>
              <el-form-item>
                <div class="flex">
                  <div class="qux" @click="resetForm('ruleForm')">取消</div>
                  <div class="sub" @click="submitForm('ruleForm')">
                    保存发票信息
                  </div>
                </div>
              </el-form-item>
            </el-form>
            <!--  -->
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="增票资质确认书" :visible.sync="dialogTableVisible">
      <div class="" v-html="ticket"></div>
      <el-button
        type="primary"
        @click.stop="dialogTableVisible = false"
        class="dialog_foot"
        >确认</el-button
      >
    </el-dialog>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import Userheader from "./components/user_index";
import Usernavleft from "./components/user_navleft";
export default {
  components: {
    Header,
    Userheader,
    Usernavleft,
    Foot,
  },
  data() {
    return {
      ruleForm: {
        region: "", //发票类型  0 普通发票 1 增值税普通票 2增值税专用票
        taxpayer: "", //纳税人
        resource: "", //发票类型 分企业还是个人
        invoicetitle: "", //发票抬头
        openingbank: "", //开户行
        bankaccount: "", //银行账户
        address: "", //注册地址
        phone: "", //电话
        checked: "",
      },
      rules: {
        region: [
          { required: true, message: "请选择发票类型", trigger: "change" },
        ],
        resource: [
          { required: true, message: "请选择发票类型", trigger: "change" },
        ],
        invoicetitle: [
          { required: true, message: "请输入发票抬头", trigger: "blur" },
        ],
        taxpayer: [
          { required: true, message: "请输入纳税人识别码", trigger: "blur" },
        ],
        openingbank: [
          { required: true, message: "请输入开户行", trigger: "blur" },
        ],
        bankaccount: [
          { required: true, message: "请输入银行账户", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入注册地址", trigger: "blur" },
        ],
        phone: [{ required: true, message: "请输入注册电话", trigger: "blur" }],
        checked: [{ required: true, message: "请阅读并同意", trigger: "blur" }],
      },
      invoice_id: "",
      ticket: "",
      dialogTableVisible: false,
      invoice_type: "",
    };
  },
  mounted() {},
  created() {
    if (this.$route.query.id) {
      this.invoice_id = this.$route.query.id;
      this.getdetails();
    }
    this.qualification();
  },
  methods: {
    increased() {
      this.dialogTableVisible = !this.dialogTableVisible;
    },
    qualification() {
      var that = this;
      this.$api
        .articleDetail({
          id: "incre_ticket",
        })
        .then((res) => {
          if (res.code == 0) {
            that.ticket = res.data.content;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getdetails() {
      var that = this;
      this.$api
        .invoice_detail({
          id: this.invoice_id,
        })
        .then((res) => {
          // console.log(res)
          if (res.code == 0) {
            if (res.data.invoice_type == 0) {
              that.ruleForm.region = "普通发票";
            } else if (res.data.invoice_type == 1) {
              that.ruleForm.region = "增值税普通发票";
            } else if (res.data.invoice_type == 2) {
              that.ruleForm.region = "增值税专用发票";
            }
            that.ruleForm.resource = res.data.type;
            that.invoice_type = res.data.invoice_type;
            if (res.data.header) {
              that.ruleForm.invoicetitle = res.data.header;
            }
            if (res.data.taxpayer) {
              that.ruleForm.taxpayer = res.data.taxpayer;
            }
            if (res.data.bank_account) {
              that.ruleForm.openingbank = res.data.bank_account;
            }
            if (res.data.bank_num) {
              that.ruleForm.bankaccount = res.data.bank_num;
            }
            if (res.data.register_address) {
              that.ruleForm.address = res.data.register_address;
            }
            if (res.data.register_tel) {
              that.ruleForm.phone = res.data.register_tel;
            }
          } else {
            that.$message({
              message: "" + res.msg,
              type: "warning",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    individual(e) {
      this.ruleForm.resource = e;
      this.ruleForm.region = "";
      this.ruleForm.invoicetitle = "";
      this.ruleForm.taxpayer = "";
      this.ruleForm.openingbank = "";
      this.ruleForm.bankaccount = "";
      this.ruleForm.address = "";
      this.ruleForm.phone = "";
    },
    regionchange(e) {
      this.ruleForm.region = e;
      this.ruleForm.invoicetitle = "";
      this.ruleForm.taxpayer = "";
      this.ruleForm.openingbank = "";
      this.ruleForm.bankaccount = "";
      this.ruleForm.address = "";
      this.ruleForm.phone = "";
    },
    submitForm(formName) {
     
      var that = this;
      if (this.ruleForm.invoicetitle == 0) {
        that.$message({
          message: "抬头不能填写0",
          type: "warning",
        });
        return false;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(this.ruleForm);
          that.addinvoice();
        } else {
          that.$message({
            message: "请您填写上述信息",
            type: "warning",
          });
          return false;
        }
      });
    },
    addinvoice() {
      var that = this;
      let invoice_type = this.ruleForm.region;
      if (this.ruleForm.region == "普通发票") {
        invoice_type = 0;
      } else if (this.ruleForm.region == "增值税普通发票") {
        invoice_type = 1;
      } else if (this.ruleForm.region == "增值税专用发票") {
        invoice_type = 2;
      }
      let params = {
        type: this.ruleForm.resource,
        invoice_type: invoice_type,
        header: this.ruleForm.invoicetitle,
        taxpayer: this.ruleForm.taxpayer,
        bank_account: this.ruleForm.openingbank,
        bank_num: this.ruleForm.bankaccount,
        register_address: this.ruleForm.address,
        register_tel: this.ruleForm.phone,
      };
      if (this.invoice_id) {
        params.id = this.invoice_id;
      }
      that.$api
        .addinvoice(params)
        .then((res) => {
          // console.log(res)
          if (res.code == 0) {
            that.$router.replace("/ttshop_invoiceInformation");
          } else {
            that.$message({
              message: "" + res.msg,
              type: "warning",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style  lang="scss" scoped>
::v-deep .el-dialog__header {
  text-align: center;
}
.dialog_foot {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  margin-top: 20px;
}
.ttshop_coupon {
  width: 100%;
  background: #fff;
  padding: 24px 20px;
  box-sizing: border-box;
  .fap_title {
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
  }
  .el-input {
    width: 280px !important;
  }
  .el-select {
    width: 280px;
  }
  ::v-deep .el-form-item__error {
    background: url(../../assets/icontishi.png) no-repeat;
    top: 30%;
    left: 290px;
    padding: 0px 0px 0px 20px;
    color: #ff8500;
  }
  .red {
    color: #ff0e25;
  }
  .qux {
    width: 80px;
    height: 30px;
    border-radius: 2px;
    border: 1px solid #ff0e25;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ff0e25;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
  }
  .sub {
    width: 114px;
    height: 32px;
    background: #ff0e25;
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    line-height: 32px;
    margin-left: 16px;
    cursor: pointer;
  }
  .flex {
    display: flex;
  }
}
</style>
